<div class="wizard-wrapper">
  <c-wizard-header
    [title]="title"
    [steps]="wizardStepNames"
    [activeStep]="activeStep" />

  <ng-content></ng-content>
</div>
